import { createLogic } from 'redux-logic';
import { AUTH_TOKEN_KEY } from 'config/constants';
import * as localStore from 'lib/localStore';
import setSBAAuthenticationCookie from 'lib/setSBAAuthenticationCookie';
import * as sbaActions from '../sba/actions';

const sbaAuthenticationUpdate = createLogic({
  type: [sbaActions.createSBAAuthenticationSuccess, sbaActions.updateSBAAuthentication],
  process({ action }) {
    const { token } = action.payload;
    localStore.setJson(AUTH_TOKEN_KEY, token);
    setSBAAuthenticationCookie(token);
  },
});

export default sbaAuthenticationUpdate;
